import { render, staticRenderFns } from "./AgentFeaturePromotionDialog.vue?vue&type=template&id=0c948098&scoped=true"
import script from "./AgentFeaturePromotionDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgentFeaturePromotionDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AgentFeaturePromotionDialog.vue?vue&type=style&index=0&id=0c948098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c948098",
  null
  
)

export default component.exports